import React, { forwardRef } from 'react';
import { Tabs, Tab, Typography } from '@material-ui/core';
import { scrollToElement } from 'menus/providers/MenuScrollListenerProvider/scrolling-utils';
import { useMenuScrollFromParams } from 'menus/hooks';
import { useMenuScrollListener } from 'menus/providers';
import MainCategoryIcon from './MainCategoryIcon';
import styles from './MainCategoriesBar.styles';

const MainCategoriesBar = forwardRef<any, any>(({ categories }: any, ref) => {
  const classes = styles();

  useMenuScrollFromParams(categories);

  const { selectedCategory } = useMenuScrollListener();

  return (
    <Tabs
      variant="scrollable"
      aria-label="Menu categories"
      data-testid="main-category-bar"
      value={selectedCategory.id}
      className={classes.categoriesContainer}
      component="nav"
      ref={ref}
    >
      {categories.map((category) => (
        <Tab
          key={category.id}
          component="button"
          onClick={scrollToElement(category.ref)}
          data-testid={`category-button-${category.id}`}
          label={<Typography variant="body2">{category.category}</Typography>}
          icon={
            <MainCategoryIcon
              id={category.iconName}
              darkMode={category.id === selectedCategory.id}
              className={classes.icon}
            />
          }
          value={category.id}
          classes={{
            root: classes.tab,
            selected: classes.selectedCategory,
            wrapper: classes.tabElement,
            labelIcon: classes.tabLabelIcon,
          }}
        />
      ))}
    </Tabs>
  );
});

export default MainCategoriesBar;
